export default __webpack_public_path__ + "static/hiv-testing_outside-deskop-5652a78df32b75691d3677ea1267fa61.jpg";